"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeObject = exports.theme = exports["default"] = void 0;
var _styles = require("@material-ui/core/styles");
var _palette = _interopRequireDefault(require("./palette"));
var _typography = _interopRequireDefault(require("./typography"));
var _overrides = _interopRequireDefault(require("./overrides"));
const themeObject = {
  palette: _palette["default"],
  typography: _typography["default"],
  overrides: _overrides["default"],
  zIndex: {
    appBar: 1200,
    drawer: 1100
  }
};
exports.themeObject = themeObject;
const theme = (0, _styles.createTheme)(themeObject);
exports.theme = theme;
var _default = theme;
exports["default"] = _default;